import { render, staticRenderFns } from "./TapPage.vue?vue&type=template&id=62fc0062&scoped=true"
import script from "./TapPage.vue?vue&type=script&lang=js"
export * from "./TapPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc0062",
  null
  
)

export default component.exports